function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'charbon': 'rgb(84, 88, 90)','olive': 'rgb(141, 139, 110)','noir': 'rgb(0, 0, 0)','blanc': 'rgb(255, 255, 255)','vert': 'rgb(106, 127, 120)','gris': 'rgb(178, 180, 178)','cyan': 'rgb(57, 170, 187)','marine': 'rgb(32, 44, 65)','vert-alpin': 'rgb(98, 122, 119)','toast': 'rgb(140, 92, 46)','old-pink': 'rgb(160, 107, 97)','rouge-179': 'rgb(251, 13, 27)','turquoise-320': 'rgb(0, 156, 166)','vert-355': 'rgb(0, 150, 57)','vert-foret-574': 'rgb(75, 91, 39)','jaune-fonce-1245': 'rgb(198, 146, 20)','orange-1525': 'rgb(185, 71, 0)','mauve-2583': 'rgb(148, 83, 165)','vieux-rose-opnk': 'rgb(160, 107, 97)','menthe': 'rgb(130, 195, 197)','518': 'rgb(75, 48, 72)','181': 'rgb(127, 2, 9)','464': 'rgb(140, 92, 46)','3165': 'rgb(0, 79, 89)','7536': 'rgb(133, 130, 97)','dark-gray': 'rgb(56, 54, 53)',};

    this.images = {'splatter-camo': 'url("//www.ragcustom.com/cdn/shop/files/SPLATERCAMO_68x.png?v=10332390960887200586")','floral': 'url("//www.ragcustom.com/cdn/shop/files/FLORAL_68x.png?v=9034746492511886099")','foliage': 'url("//www.ragcustom.com/cdn/shop/files/FOLIAGE_68x.png?v=8626523059070364640")','camo': 'url("//www.ragcustom.com/cdn/shop/files/CAMO_68x.png?v=10988247139071341887")','scratch-art': 'url("//www.ragcustom.com/cdn/shop/files/SCRATCHART_68x.png?v=8945806453468392882")','leopard': 'url("//www.ragcustom.com/cdn/shop/files/LEOPARD_68x.png?v=14734633281612091802")','palm': 'url("//www.ragcustom.com/cdn/shop/files/PALM_68x.png?v=14366712701848197694")','gray-camo': 'url("//www.ragcustom.com/cdn/shop/files/GRAYCAMO_68x.png?v=11679264046105623635")','caps': 'url("//www.ragcustom.com/cdn/shop/files/CAPS_68x.png?v=240088586507253575")','sticker-bomb': 'url("//www.ragcustom.com/cdn/shop/files/STICKERBOMB_68x.png?v=10694419938857501517")','tie-dye': 'url("//www.ragcustom.com/cdn/shop/files/TIEDYE_68x.png?v=16402044784066834236")','foliage-bleu-297': 'url("//www.ragcustom.com/cdn/shop/files/FOLIAGE-BLEU297_68x.png?v=8989856640212442361")','noir-vert-rag': 'url("//www.ragcustom.com/cdn/shop/files/NOIR-VERTRAG_68x.png?v=13546014335888217906")','rouge-1805-jaune-394': 'url("//www.ragcustom.com/cdn/shop/files/ROUGE1805-JAUNE394_68x.png?v=13766226541500445946")','turquoise-320-blanc': 'url("//www.ragcustom.com/cdn/shop/files/TURQUOISE320-BLANC_68x.png?v=3709165019406459227")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
